// extracted by mini-css-extract-plugin
module.exports = {"root":"sdYYy","item":"y05eN","marquee":"lHwPE","separator":"a0MOC","text-large":"TJDf7","text-small":"OGsi9"};